export default __webpack_public_path__ + "static/Row 5.3_WCS-fc2fde958292d1d36841c9fff2c9bf5c.jpg";